// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_rWl","cls2":"News-cls2_j-5 News-cls1_rWl"};